<template>
  <DashboardQuestions />
</template>

<script>
import DashboardQuestions from "../../components/DashboardQuestions";
export default {
  name: "BETTER",
  components: {
    DashboardQuestions,
  },
};
</script>